import { useSuspenseQuery } from '@tanstack/react-query';

import { getProceedingValidationHistoryOptions } from '@/module/Author/Proceeding/Validation/model/ProceedingValidationModel';

import { Id } from '@feature/utils';
import { ValidationHistoryContent } from '@feature/validation/ValidationHistoryContent';

interface ProceedingValidationHistoryProps {
  proceedingId: Id;
}

export function ProceedingValidationHistory({ proceedingId }: ProceedingValidationHistoryProps) {
  const { data: history } = useSuspenseQuery(getProceedingValidationHistoryOptions(proceedingId));

  return <ValidationHistoryContent history={history} />;
}
